export default {
	tenantId: "coverGo_demo",
	appId: "covergo_crm",

	fileSystem: {
		bucketName: "covergo--demo"
	}
}
